import React from "react";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";

const SyntheseAnnuelle = ({ listData }) => {
  const options = { year: "numeric", month: "long", day: "numeric" };
  const style = { fontFamily: "sans-serif" };
  return (
    <>
      {listData.allowed ? (
        <Col>
          <CardTitle style={{ color: "#555b21" }} className="mb-2">
            {listData.title}
          </CardTitle>
          <Card className="mini-stats-wid">
            <CardBody>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead className="nowrap-header">
                    <tr>
                      {listData.header.map((item, index) => (
                        <th key={index} className="text-nowrap">
                          {item}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {listData.data.length > 0 ? (
                      listData.data.map((item) => (
                        <tr key={item.id}>
                          <>
                            <td>{item.conseil}</td>
                            <td>{item.investisseur}</td>
                            <td
                              style={{
                                fontFamily: "sans-serif",
                                textAlign: "right",
                              }}
                            >
                              {item.montant?.toLocaleString("fr-FR", {
                                style: "currency",
                                currency: "EUR",
                              }) || "0,00 €"}
                            </td>

                            <td
                              style={{
                                fontFamily: "sans-serif",
                                textAlign: "center",
                              }}
                            >
                              {new Date(
                                item.date_de_creation
                              ).toLocaleDateString("fr-FR")}
                            </td>
                            <td>{item.mode_reglement}</td>
                            {item.statut == "Dossier signé" ? (
                              <td>
                                <span
                                  style={{ fontSize: "100%" }}
                                  className="bg-success badge bg-secondary"
                                >
                                  {item.statut}
                                </span>
                              </td>
                            ) : (
                              <td style={style}>
                                <span className="bg-info badge bg-secondary">
                                  {item.statut}
                                </span>
                              </td>
                            )}
                          </>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={listData.header.length}>
                          Aucune donnée disponible
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default SyntheseAnnuelle;
